export default __webpack_public_path__ + "static/media/bubble1.d49009d9.png";